import React, { forwardRef, PropsWithChildren, useCallback } from 'react';
import { IPaymentOptionCardProps } from './models';
import * as styles from './styles';
import styled from 'styled-components';
import { Card } from '../card/Card';

export const PaymentOptionCard = styled(
  forwardRef<HTMLDivElement, PropsWithChildren<IPaymentOptionCardProps>>(
    (
      {
        className,
        children,
        loaderContent,
        expandedContent,
        isSelected,
        isInitialyExpanded,
        handleSelect,
        isLoading,
        numOfPayments,
        paymentAmount,
        isExpandable,
        alwaysOpenCards,
        breakingSizeQuery,
      },
      ref
    ) => {
      return (
        <div className={className}>
          <Card
            {...{
              className: 'card',
              ref,
              isLoading,
              isExpandable,
              isSelected,
              loaderContent,
              expandedContent,
              isInitialyExpanded,
              handleSelect,
              breakingSizeQuery,
            }}
            isSelectable
          >
            <div>
              <h1>{numOfPayments}</h1>
              monthly payments of
              <h3 data-at="paymentAmountTxt">{paymentAmount}</h3>
            </div>
          </Card>
        </div>
      );
    }
  )
)`
  ${styles.PaymentOptionCard}
`;

PaymentOptionCard.defaultProps = {
  isSelected: false,
  isInitialyExpanded: false,
  isLoading: false,
  isExpandable: true,
};
